import { api } from "./axios.config";
import axios from "./axios";
import { getCurrentEventId } from "../Utils/helpers";

const API_URL = api.apiUrl;
const BASE_URL = "/event/";

export const getAllCustomCheckins = () => {
    const eventId = getCurrentEventId();
    return axios.get(API_URL + BASE_URL + eventId + `/custom-checkins`);
};

export const createCustomCheckins = (payload) => {
    const eventId = getCurrentEventId();
    return axios.post(API_URL + BASE_URL + eventId + `/custom-checkins`, payload);
};

export const updateCustomCheckin = (checkinId, payload) => {
    const eventId = getCurrentEventId();
    const url = API_URL + BASE_URL + eventId + `/custom-checkins/` + checkinId;
    return axios.put(url, payload);
};

export const deleteCustomCheckin = (checkinId) => {
    const eventId = getCurrentEventId();
    const url = API_URL + BASE_URL + eventId + `/custom-checkins/` + checkinId;
    return axios.delete(url);
};

export const validateCustomCheckinName = (checkinName) => {
    const eventId = getCurrentEventId();
    const url = API_URL + BASE_URL + eventId + `/custom-checkins/validate`;
    return axios.get(url, {
        params: {
            checkin_name: checkinName,
        },
    });
};


export const getAllMultiCheckins = () => {
    const eventId = getCurrentEventId();
    return axios.get(API_URL + BASE_URL + eventId + `/custom-checkins`);
};

export const fetchCheckinAnalytics = async (checkinId, isDefault) => {
    const eventId = getCurrentEventId();

    try {
        const params = { checkin_id: checkinId, is_default: isDefault };

        return axios.get(`${API_URL}${BASE_URL}${eventId}/checkins/analytics`, { params });

    } catch (error) {
        console.error("Error fetching check-in analytics:", error);
        throw error;
    }
};
